import React from "react";

const Header = () => {
    return (
        <div className={"row"}>
            <p className={"page-header"}>Drag-n-Drop Dashboard📌</p>
        </div>
    );
};

export default Header;